import { NavLink, Outlet, RouteObject } from "react-router";

import { Badge, BadgeColor, checkTabIsActive, PageHeading, Tabs } from "@prequel/shared-components";

import AlertsTable from "./AlertsTable";
import OverviewChart from "./OverviewChart";
import SuccessesTable from "./SuccessesTable";

import { useDestinations } from "@/api/queries/destinations";

const OverviewPage = () => {
  const { data: destinations = [] } = useDestinations({ pageSize: 100 });

  const errorDestinations = destinations?.filter((transfer) => transfer.last_completed_transfer?.status != "SUCCESS");

  const tabs = [
    <NavLink key="Alerts" to="/overview" className={checkTabIsActive} replace end>
      {({ isActive }) => (
        <div className="space-x-2.5">
          <span>Alerts</span>
          {errorDestinations?.length && errorDestinations.length > 0 ? (
            <Badge text={errorDestinations.length.toString()} color={isActive ? BadgeColor.RED : BadgeColor.GRAY} />
          ) : undefined}
        </div>
      )}
    </NavLink>,
    <NavLink key="Successes" to="/overview/successes" className={checkTabIsActive} replace end>
      Successes
    </NavLink>,
  ];

  return (
    <div className="max-w-6xl px-7 py-4 pb-16">
      <PageHeading title="Overview" />
      <OverviewChart />
      <Tabs tabs={tabs} />
      <Outlet
        context={{
          errorDestinations,
          successDestinations: destinations?.filter(
            (transfer) => transfer.last_completed_transfer?.status == "SUCCESS",
          ),
        }}
      />
    </div>
  );
};

export const overviewRoutes: RouteObject = {
  path: "overview",
  handle: {
    breadcrumb: () => ({ label: "Overview" }),
  },
  element: <OverviewPage />,
  children: [
    {
      index: true,
      element: <AlertsTable />,
    },
    {
      path: "successes",
      element: <SuccessesTable />,
    },
  ],
};

export default OverviewPage;
